// extracted by mini-css-extract-plugin
export default {"containprod":"CG","containprod2":"EG","title":"FG","servings":"GG","recommendation":"HG","image":"IG","flavorswrap":"JG","flavorsgroupwrap":"KG","moredetailsWrap":"LG","infoWrap":"MG","price":"NG","regularPrice":"OG","netPrice":"PG","addtocartcontainer":"QG","error":"RG"};
    if(module.hot) {
      // 1713912566104
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  